import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltip } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { CommentsModule } from '@empathy/comments/feature';
import { SurveyCoreModule } from '@empathy/survey-core';
import { EmpathyViewerModule } from '@empathy/survey-deprecated-viewer';
import { EmpathyEditorModule } from '@empathy/survey-editor';

import { CarouselFormComponent } from './components/carousel-form/carousel-form.component';
import { ChoicesFormComponent } from './components/choices-form/choices-form.component';
import { FlagsFormComponent } from './components/flags-form/flags-form.component';
import { GeneralProgrammerNotesDialogComponent } from './components/general-programmer-notes-dialog/general-programmer-notes-dialog.component';
import { NotepadFullPreviewComponent } from './components/notepad-full-preview/notepad-full-preview.component';
import { NotepadSideTabsComponent } from './components/notepad-side-tabs/notepad-side-tabs.component';
import { QuestionFormComponent } from './components/question-form/question-form.component';
import { QuestionTypeSelectComponent } from './components/question-type-select/question-type-select.component';
import { RanksFormComponent } from './components/ranks-form/ranks-form.component';
import { SelectTypeButtonComponent } from './components/select-type-button/select-type-button.component';
import { ToggleComponent } from './components/toggle/toggle.component';
import { NotepadComponent } from './containers/notepad/notepad.component';

@NgModule({
  imports: [
    A11yModule,
    CommentsModule,
    CommonModule,
    DragDropModule,
    EmpathyEditorModule,
    EmpathyViewerModule,
    FontAwesomeModule,
    FormsModule,
    HttpClientModule,
    MatBadgeModule,
    MatButtonModule,
    MatChipsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltip,
    OverlayModule,
    ReactiveFormsModule,
    SurveyCoreModule
  ],
  declarations: [
    ChoicesFormComponent,
    FlagsFormComponent,
    GeneralProgrammerNotesDialogComponent,
    NotepadComponent,
    NotepadFullPreviewComponent,
    NotepadSideTabsComponent,
    QuestionFormComponent,
    QuestionTypeSelectComponent,
    RanksFormComponent,
    SelectTypeButtonComponent,
    CarouselFormComponent,
    ToggleComponent
  ],
  exports: [NotepadComponent, NotepadFullPreviewComponent]
})
export class EmpathyNotepadModule {}
